import { usePermission } from 'hooks/usePermission';
import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router';
import { NotFoundPage } from './components/NotFoundPage/Loadable';
import LoaderWrapper from './components/CircularLoader/LoaderWrapper';
import CircularLoader from './components/CircularLoader';
import Cookies from 'js-cookie';

export type ProtectedRouteProps = {
  isAuthenticated: boolean;
  authenticationPath: string;
  redirectPath?: string;
  setRedirectPath?: (path: string) => void;
  outlet: JSX.Element;
  permissionId?: string;
};

export default function ProtectedRoute({
  isAuthenticated,
  outlet,
  redirectPath,
  setRedirectPath,
  authenticationPath,
  permissionId,
}: ProtectedRouteProps) {
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  const currentLocation = useLocation();
  const { hasViewPermission } = usePermission();
  const userType = Cookies.get('userType');
  const hasPermission = hasViewPermission(permissionId ?? '');

  // Check if user is COACH and trying to access allowed routes
  const isCoachAllowedRoute =
    (userType === 'COACH' || userType === 'TEAMUSER') &&
    (currentLocation.pathname.includes('/coaches') ||
      currentLocation.pathname.includes('/riders') ||
      currentLocation.pathname.includes('/dashboard') ||
      currentLocation.pathname.includes('/teams'));

  if (
    isAuthenticated &&
    currentLocation.pathname.includes(redirectPath!.toString()) &&
    (hasPermission || isCoachAllowedRoute)
  ) {
    return outlet;
  } else if (isAuthenticated && !hasPermission && !isCoachAllowedRoute) {
    return isLoading ? (
      <LoaderWrapper>
        <CircularLoader />
      </LoaderWrapper>
    ) : (
      <NotFoundPage />
    );
  } else {
    return <Navigate to={{ pathname: authenticationPath }} />;
  }
}
